import { h } from "omi";

import { IconProps } from "@/components";

export function LinkedInIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" width={width} height={height}>
      <path
        fill="currentColor"
        d="M22.6219.5H2.17031C1.19062.5.398438 1.27344.398438 2.22969V22.7656c0 .9563.792182 1.7344 1.771872 1.7344H22.6219c.9797 0 1.7765-.7781 1.7765-1.7297V2.22969C24.3984 1.27344 23.6016.5 22.6219.5ZM7.51875 20.9516h-3.5625V9.49531h3.5625V20.9516ZM5.7375 7.93438c-1.14375 0-2.06719-.92344-2.06719-2.06251 0-1.13906.92344-2.0625 2.06719-2.0625 1.13906 0 2.0625.92344 2.0625 2.0625 0 1.13438-.92344 2.06251-2.0625 2.06251ZM20.85 20.9516h-3.5578v-5.5688c0-1.3266-.0235-3.0375-1.8516-3.0375-1.8515 0-2.1328 1.4484-2.1328 2.9438v5.6625H9.75469V9.49531h3.41251v1.56559h.0469c.4734-.9 1.6359-1.85152 3.3656-1.85152 3.6047 0 4.2703 2.37192 4.2703 5.45622v6.286Z"
      />
    </svg>
  );
}
